// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__7f5XO","footer":"ReportModalFilter_footer__NvgAL"};